// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e4d8e5c8","977":"4d20bd32"}[chunkId] + ".chunk.js";
};